<template>
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 prodgroup-wrp">
        <template v-if="imagecards === 'true'">
            <a class="prodcard-container images" :href="'/'+locale+'/'+product['uid']" target="_blank">
                <div class="img-container">
                    <img :data-src="product['image_product']['url']" alt="" class="lazy img img-responsive">
                </div>
                <div class="prodcard-txt">
                    <span class="prodcard-icon" :class="product['icon_field']"></span>
                    <span class="prodcard-name text-uppercase">{{ product['product_name']}}</span>
                </div>
            </a>
        </template>

        <template v-else>
            <a :href="product['related_landing_page']" class="prodcard-container no-images">
                <div class="prodcard-txt table-bordered">
                    <span class="prodcard-icon" :class="product['icon_field']"></span>
                    <span class="prodcard-name text-uppercase">{{ product['product_name']}}</span>
                </div>
            </a>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['product', 'imagecards', 'locale'],
        name: "RelatedProduct"
    }
</script>

<style scoped>
    .prodcard-txt {
        font-size: 12px;
    }

    .prodcard-container{
        border-radius: 5px;
    }

    .prodgroup-wrp {
        max-width: inherit;
    }

    .prodgroup-wrp a {
        position: relative;
    }

    .prodcard-name {
        font-size: 16px;
        font-weight: bold;
    }

    .prodcard-txt {
        background-color: #fff;
        display: flex;
        padding: 15px;
        height: 100%;
        position: absolute;
    }

    .prodcard-icon {
        color: inherit;
        width: 100%;
        text-align: center;
        position: static;
        font-size: 60px;
    }

    .prodcard-txt:hover .prodcard-icon {
        color: #fff;
    }

    .cards-shadow .prodcard-txt {
        height: 80%;
        margin-top: 10%;
        background-color: rgba(0,0,0,0.5);
    }

    .prodcard-container.no-images {
        position: relative;
        padding-top: 100%;
        color: #fff;
        display: block;
        overflow: hidden;
        border-radius: 5px;
    }

    .prodcard-container.no-images:hover {
        color: #fff;
    }

    .prodcard-container.no-images .prodcard-txt {
        background-color: #fff;
        border-radius: 5px;
        color: $color-black-russian;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 15px;
        height: 100%;
        position: absolute;
        border: 1px solid rgb(221, 221, 221);
        margin-top: 0;
    }

    .prodcard-container.no-images .prodcard-icon {
        color: #7DBB97;
        width: 100%;
        text-align: center;
        position: static;
        font-size: 100px;
    }

    @media all and (min-width: 992px){
        .cards-shadow .prodcard-txt {
            border-right: 0;
            border-left: 0;
        }

        .prodcard-container.no-images .prodcard-txt:hover {
            background-color: #7DBB97;
            border-color: #7DBB97;
            color: #fff;
        }
    }

    @media all and (max-width: 991px) {
        .prodgroup-wrp {
            margin-bottom: 15px !important;
        }

        .prodcard-txt {
            max-width: 380px;
            margin: 0 auto;
            border: 1px solid #ddd;
            border-radius: 0 5px 5px 0;
        }

        .prodcard-name {
            margin-left: 0;
            position: relative;
        }

        .prodgroup-wrp {
            padding-right: 0;
        }

        .prodgroup-wrp a {
            min-height: 100px;
            max-width: 380px;
            margin: 0 auto;
            padding-top: 0;
            position: relative;
        }

        .prodcard-icon {
            width: 100px;
            position: absolute;
            left: 15px;
        }

        .img-cards .prodgroup-wrp {
            margin-bottom: 30px !important;
        }

        .img-cards .prodgroup-wrp a {
            padding-top: 0;
            border: 1px solid #ddd;
            border-radius: 0 5px 5px 0;
            margin: 0 auto;
        }

        .img-cards .prodcard-container a {
            width: 100%;
        }

        .img-cards .prodcard-container .img-container {
            border-radius: 5px 0 0 5px;
            max-width: 120px;
            min-height: 120px;
            position: relative;
            top: 0;
            left: 0;
        }

        .img-cards .prodcard-container .img-responsive {
            max-width: inherit;
            border-radius: 0;
            position: static;
        }

        .img-cards .prodcard-txt {
            background-color: transparent;
            color: rgb(51, 51, 51);
            height: initial;
            margin-top: 0;
            min-height: 120px;
            position: absolute;
            left: 120px;
            width: calc(100% - 120px);
        }

        .img-cards .prodcard-icon {
            display: none;
        }

        .prodgroup-wrp {
            margin-bottom: 15px !important;
        }

        .prodcard-icon {
            font-size: 80px;
        }

        .prodcard-container.no-images {
            height: 125px;
            padding-top: 0;
            margin: 0;
            max-width: inherit;
        }

        .prodcard-container.no-images .prodcard-txt {
            left: 0;
            width: 100%;
            max-width: inherit;
        }

        .prodcard-container.no-images .prodcard-icon {
            width: 100px;
            position: absolute;
            top: 15px;
            left: 15px;
            font-size: 80px;
            display: block;
        }

        .prodcard-container.no-images .prodcard-name {
            font-size: 16px;
            width: calc(100% - 100px);
            left: 100px;
            position: relative;
        }
    }

    @media all and (min-width: 1440px) {
        .prodgroup-wrp a {
            padding-top: 0;
            min-height: 202px;
        }
    }

    @media all and (min-width: 1200px) and (max-width: 1439px) {
        .prodcard-txt {
            max-height: 178px;
            min-height: 178px;
            padding: 15px 5px;
        }

        .prodcard-name{
            font-size: 14px;
        }

        .prodcard-icon {
            padding: 0;
            font-size: 40px;
        }

        .prodgroup-wrp a {
            padding-top: 0;
            min-height: 178px;
        }

        .cards-shadow .prodcard-txt {
            height: 50%;
            margin-top: 0;
        }
    }

    @media all and (min-width: 992px) and (max-width: 1199px) {
        .prodcard-icon {
            font-size: 100px;
        }

        .prodcard-txt {
            padding: 15px 5px;
        }

        #landing-checkout .col-md-6 {
            width: 25% !important;
        }

        #cards-shadow .prodcard-txt {
            height: 50%;
            margin-top: 25%;
        }
    }

    @media all and (max-width: 991px) and (min-width: 768px) {
        .prodcard-txt {
            margin: 0 auto;
        }

        .prodcard-name {
            margin-left: 0;
            position: relative;
        }

        .prodgroup-wrp a {
            min-height: 115px;
            padding-top: 0;
            position: relative;
        }

        .prodcard-icon {
            width: 100px;
            position: absolute;
            left: 15px;
        }

        a {
            margin-right: 10px !important;
        }
    }

    @media all and (max-width: 767px) {
        .prodcard-icon {
            display: none;
        }

        .prodcard-container.no-images {
            max-width: 380px;
            margin: auto;
        }
    }
</style>
